// @ts-nocheck

import { UserMissionsStateActionTypes } from '../types/actions/userMissions';

export const updateUserMissionsState = ({ userMissionsMutation }) => ({
  type: UserMissionsStateActionTypes.UPDATE_STATE,
  payload: {
    userMissionsMutation,
  },
});

export const updateRegisteredMissions = ({ registeredMissionsMutation }) => ({
  type: UserMissionsStateActionTypes.UPDATE_REGISTERED_MISSIONS,
  payload: {
    registeredMissionsMutation,
  },
});

export const requestRefreshUserMissionsState = () => ({
  type: UserMissionsStateActionTypes.REQUEST_REFRESH_USER_MISSIONS_STATE,
});

export const refreshUserMissionsState = () => ({
  type: UserMissionsStateActionTypes.REFRESH_USER_MISSIONS_STATE,
});
